import { Icon, IconProps } from '@chakra-ui/react';

export const MinusIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 14 2"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="1" y1="1" x2="13" y2="1" />
  </Icon>
);

export const PlusIcon = (props: IconProps) => (
  <Icon
    viewBox="0 0 14 14"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="1" y1="7" x2="13" y2="7" />
    <line x1="7" y1="13" x2="7" y2="1" />
  </Icon>
);

export const PinIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 14 19"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M7 10.125C8.38071 10.125 9.5 9.00571 9.5 7.625C9.5 6.24429 8.38071 5.125 7 5.125C5.61929 5.125 4.5 6.24429 4.5 7.625C4.5 9.00571 5.61929 10.125 7 10.125Z" />
    <path d="M13.25 7.625C13.25 13.25 7 17.625 7 17.625C7 17.625 0.75 13.25 0.75 7.625C0.75 5.9674 1.40848 4.37769 2.58058 3.20558C3.75269 2.03348 5.3424 1.375 7 1.375C8.6576 1.375 10.2473 2.03348 11.4194 3.20558C12.5915 4.37769 13.25 5.9674 13.25 7.625V7.625Z" />
  </Icon>
);

export const ClockIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 16 17"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M8 16C12.1421 16 15.5 12.6421 15.5 8.5C15.5 4.35786 12.1421 1 8 1C3.85786 1 0.5 4.35786 0.5 8.5C0.5 12.6421 3.85786 16 8 16Z"
      strokeMiterlimit="10"
    />
    <path d="M8 4.125V8.5H12.375" />
  </Icon>
);

export const PhoneIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M5.22471 8.25109C5.87302 9.57651 6.94739 10.646 8.27575 11.2883C8.37294 11.3343 8.48045 11.3543 8.58769 11.3462C8.69493 11.338 8.79822 11.3021 8.88737 11.242L10.8433 9.93775C10.9298 9.88006 11.0293 9.84487 11.1328 9.83536C11.2364 9.82585 11.3407 9.84232 11.4362 9.88328L15.0954 11.4515C15.2197 11.5043 15.3234 11.596 15.3911 11.713C15.4587 11.8299 15.4865 11.9656 15.4702 12.0997C15.3546 13.0047 14.913 13.8365 14.2282 14.4394C13.5434 15.0422 12.6624 15.3748 11.75 15.3749C8.93207 15.3749 6.22956 14.2555 4.23699 12.2629C2.24442 10.2703 1.125 7.56782 1.125 4.74989C1.12505 3.83753 1.45765 2.95647 2.06053 2.27167C2.66341 1.58688 3.49523 1.14531 4.40023 1.02966C4.53431 1.01343 4.67002 1.04122 4.78693 1.10883C4.90384 1.17644 4.99561 1.28022 5.04841 1.40452L6.61798 5.06685C6.65858 5.16158 6.67512 5.26488 6.66614 5.36755C6.65715 5.47022 6.62291 5.56908 6.56647 5.65531L5.26676 7.64123C5.2076 7.73056 5.17263 7.83372 5.16526 7.94061C5.15789 8.0475 5.17837 8.15448 5.22471 8.25109V8.25109Z" />
  </Icon>
);

export const EmptyCartIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 96 85"
    fill="currentcolor"
    stroke="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M86.9724 49.9876L94.7024 15.7782C95.1958 13.3112 93.3866 10.8442 90.7552 10.8442H26.2836L24.8034 3.60759C24.31 1.79843 22.6653 0.31822 20.8561 0.31822H4.08038C1.77782 0.31822 0.133141 2.12737 0.133141 4.26546V6.89695C0.133141 9.19951 1.77782 10.8442 4.08038 10.8442H15.4287L27.1059 67.4213C24.31 69.066 22.5008 72.0264 22.5008 75.3157C22.5008 80.4143 26.6125 84.526 31.711 84.526C36.6451 84.526 40.9213 80.4143 40.9213 75.3157C40.9213 72.8487 39.77 70.5462 38.1253 68.737H72.4992C70.8545 70.5462 69.8677 72.8487 69.8677 75.3157C69.8677 80.4143 73.9794 84.526 79.0779 84.526C84.012 84.526 88.2881 80.4143 88.2881 75.3157C88.2881 71.6974 86.15 68.5725 83.0251 67.0923L83.8475 63.1451C84.5054 60.6781 82.5317 58.211 80.0647 58.211H35.9872L34.8359 52.9481H83.0251C84.8343 52.9481 86.479 51.7968 86.9724 49.9876Z" />
  </Icon>
);

export const AlertIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 11 11"
    fill="currentcolor"
    stroke="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="5.5" cy="5.5" r="5.5" fill="#F25E5E" />
  </Icon>
);

export const LinkIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 16 16"
    fill="currentcolor"
    stroke="none"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.3537 5.64626C10.4002 5.6927 10.4371 5.74784 10.4622 5.80854C10.4874 5.86924 10.5003 5.9343 10.5003 6.00001C10.5003 6.06572 10.4874 6.13078 10.4622 6.19148C10.4371 6.25218 10.4002 6.30732 10.3537 6.35376L6.35369 10.3538C6.30723 10.4002 6.25208 10.4371 6.19138 10.4622C6.13069 10.4873 6.06563 10.5003 5.99993 10.5003C5.93424 10.5003 5.86918 10.4873 5.80849 10.4622C5.74779 10.4371 5.69264 10.4002 5.64618 10.3538C5.59973 10.3073 5.56288 10.2522 5.53774 10.1915C5.5126 10.1308 5.49966 10.0657 5.49966 10C5.49966 9.93431 5.5126 9.86926 5.53774 9.80856C5.56288 9.74786 5.59973 9.69271 5.64618 9.64626L9.64618 5.64626C9.69262 5.59977 9.74777 5.56289 9.80847 5.53773C9.86916 5.51257 9.93423 5.49962 9.99994 5.49962C10.0656 5.49962 10.1307 5.51257 10.1914 5.53773C10.2521 5.56289 10.3072 5.59977 10.3537 5.64626ZM13.4749 2.52501C13.1499 2.19997 12.7641 1.94213 12.3394 1.76621C11.9147 1.5903 11.4596 1.49976 10.9999 1.49976C10.5403 1.49976 10.0851 1.5903 9.66046 1.76621C9.2358 1.94213 8.84994 2.19997 8.52493 2.52501L6.64618 4.40313C6.55236 4.49695 6.49966 4.6242 6.49966 4.75688C6.49966 4.88957 6.55236 5.01681 6.64618 5.11063C6.74 5.20445 6.86725 5.25716 6.99993 5.25716C7.13262 5.25716 7.25986 5.20445 7.35369 5.11063L9.23244 3.23563C9.70299 2.77542 10.336 2.51933 10.9942 2.52296C11.6524 2.52658 12.2826 2.78962 12.7481 3.25499C13.2135 3.72037 13.4767 4.35052 13.4804 5.00871C13.4842 5.66689 13.2282 6.3 12.7681 6.77063L10.8887 8.64938C10.7949 8.74312 10.7421 8.87029 10.7421 9.00291C10.742 9.13554 10.7946 9.26275 10.8884 9.35657C10.9821 9.45039 11.1093 9.50313 11.2419 9.50319C11.3745 9.50325 11.5017 9.45062 11.5956 9.35688L13.4749 7.47501C13.8 7.15 14.0578 6.76415 14.2337 6.33948C14.4096 5.91482 14.5002 5.45967 14.5002 5.00001C14.5002 4.54035 14.4096 4.0852 14.2337 3.66053C14.0578 3.23587 13.8 2.85002 13.4749 2.52501ZM8.64618 10.8888L6.76743 12.7675C6.53623 13.0039 6.26044 13.1921 5.95601 13.3212C5.65158 13.4502 5.32457 13.5176 4.99392 13.5194C4.66326 13.5213 4.33553 13.4575 4.0297 13.3318C3.72387 13.2061 3.44602 13.0209 3.21223 12.7871C2.97844 12.5533 2.79336 12.2754 2.6677 11.9695C2.54204 11.6637 2.47831 11.3359 2.48019 11.0053C2.48207 10.6746 2.54952 10.3476 2.67865 10.0432C2.80777 9.73881 2.996 9.46304 3.23243 9.23188L5.11056 7.35376C5.20438 7.25994 5.25709 7.13269 5.25709 7.00001C5.25709 6.86733 5.20438 6.74008 5.11056 6.64626C5.01674 6.55244 4.88949 6.49973 4.75681 6.49973C4.62413 6.49973 4.49688 6.55244 4.40306 6.64626L2.52493 8.52501C1.86852 9.18142 1.49976 10.0717 1.49976 11C1.49976 11.9283 1.86852 12.8186 2.52493 13.475C3.18135 14.1314 4.07163 14.5002 4.99993 14.5002C5.92824 14.5002 6.81852 14.1314 7.47494 13.475L9.35369 11.5956C9.44742 11.5018 9.50005 11.3746 9.49999 11.242C9.49993 11.1094 9.44719 10.9822 9.35337 10.8884C9.25955 10.7947 9.13234 10.7421 8.99971 10.7421C8.86709 10.7422 8.73992 10.7949 8.64618 10.8888Z" />
  </Icon>
);

export const CameraIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 26 22" fill="none">
    <path
      d="M13.0005 17.3079C14.4086 17.3079 15.5987 16.8271 16.5706 15.8656C17.5425 14.904 18.0285 13.7266 18.0285 12.3335C18.0285 10.9403 17.5425 9.76298 16.5706 8.80143C15.5987 7.83989 14.4086 7.35913 13.0005 7.35913C11.5923 7.35913 10.4022 7.83989 9.43033 8.80143C8.45843 9.76298 7.97248 10.9403 7.97248 12.3335C7.97248 13.7266 8.45843 14.904 9.43033 15.8656C10.4022 16.8271 11.5923 17.3079 13.0005 17.3079ZM13.0005 15.9745C11.9534 15.9745 11.0783 15.6267 10.375 14.9309C9.6718 14.2352 9.32018 13.3694 9.32018 12.3335C9.32018 11.2976 9.6718 10.4318 10.375 9.73606C11.0783 9.04033 11.9534 8.69246 13.0005 8.69246C14.0475 8.69246 14.9227 9.04033 15.6259 9.73606C16.3291 10.4318 16.6808 11.2976 16.6808 12.3335C16.6808 13.3694 16.3291 14.2352 15.6259 14.9309C14.9227 15.6267 14.0475 15.9745 13.0005 15.9745ZM3.04815 21.6668C2.42787 21.6668 1.90995 21.4613 1.49441 21.0502C1.07887 20.639 0.871094 20.1267 0.871094 19.513V5.15399C0.871094 4.54033 1.07887 4.02794 1.49441 3.61683C1.90995 3.20572 2.42787 3.00016 3.04815 3.00016H7.03427L9.52753 0.333496H16.4734L18.9667 3.00016H22.9528C23.5731 3.00016 24.091 3.20572 24.5065 3.61683C24.9221 4.02794 25.1299 4.54033 25.1299 5.15399V19.513C25.1299 20.1267 24.9221 20.639 24.5065 21.0502C24.091 21.4613 23.5731 21.6668 22.9528 21.6668H3.04815Z"
      fill="currentcolor"
    />
  </Icon>
);

export const CardCheckedIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 125 121" fill="none">
    <path
      d="M84 46H12C10.3431 46 9 47.3431 9 49V97C9 98.6569 10.3431 100 12 100H84C85.6569 100 87 98.6569 87 97V49C87 47.3431 85.6569 46 84 46Z"
      stroke="#1D1D1B"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39 88H51"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 88H27"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.9978 61.3196H86.9978"
      stroke="#1D1D1B"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="85" cy="40" r="37" fill="white" />
    <path
      d="M98.75 32.5L80.4166 50L71.25 41.25"
      stroke="currentColor"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85 70C101.569 70 115 56.5685 115 40C115 23.4315 101.569 10 85 10C68.4315 10 55 23.4315 55 40C55 56.5685 68.4315 70 85 70Z"
      stroke="#1D1D1B"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const WarningIcon = (props: IconProps) => (
  <Icon {...props} viewBox="0 0 20 20" fill="none">
    <path
      d="M10 0.25C8.07163 0.25 6.18657 0.821828 4.58319 1.89317C2.97981 2.96451 1.73013 4.48726 0.992175 6.26884C0.254221 8.05042 0.0611382 10.0108 0.437344 11.9021C0.81355 13.7934 1.74215 15.5307 3.10571 16.8943C4.46927 18.2579 6.20656 19.1865 8.09787 19.5627C9.98919 19.9389 11.9496 19.7458 13.7312 19.0078C15.5127 18.2699 17.0355 17.0202 18.1068 15.4168C19.1782 13.8134 19.75 11.9284 19.75 10C19.7473 7.41498 18.7192 4.93661 16.8913 3.10872C15.0634 1.28084 12.585 0.25273 10 0.25ZM10 18.25C8.3683 18.25 6.77325 17.7661 5.41655 16.8596C4.05984 15.9531 3.00242 14.6646 2.37799 13.1571C1.75357 11.6496 1.59019 9.99085 1.90852 8.3905C2.22685 6.79016 3.01259 5.32015 4.16637 4.16637C5.32015 3.01259 6.79016 2.22685 8.39051 1.90852C9.99085 1.59019 11.6496 1.75357 13.1571 2.37799C14.6646 3.00242 15.9531 4.05984 16.8596 5.41655C17.7661 6.77325 18.25 8.3683 18.25 10C18.2475 12.1873 17.3775 14.2843 15.8309 15.8309C14.2843 17.3775 12.1873 18.2475 10 18.25ZM9.25 10.75V5.5C9.25 5.30109 9.32902 5.11032 9.46967 4.96967C9.61032 4.82902 9.80109 4.75 10 4.75C10.1989 4.75 10.3897 4.82902 10.5303 4.96967C10.671 5.11032 10.75 5.30109 10.75 5.5V10.75C10.75 10.9489 10.671 11.1397 10.5303 11.2803C10.3897 11.421 10.1989 11.5 10 11.5C9.80109 11.5 9.61032 11.421 9.46967 11.2803C9.32902 11.1397 9.25 10.9489 9.25 10.75ZM11.125 14.125C11.125 14.3475 11.059 14.565 10.9354 14.75C10.8118 14.935 10.6361 15.0792 10.4305 15.1644C10.225 15.2495 9.99875 15.2718 9.78052 15.2284C9.56229 15.185 9.36184 15.0778 9.2045 14.9205C9.04717 14.7632 8.94003 14.5627 8.89662 14.3445C8.85321 14.1262 8.87549 13.9 8.96064 13.6945C9.04578 13.4889 9.18998 13.3132 9.37498 13.1896C9.55999 13.066 9.7775 13 10 13C10.2984 13 10.5845 13.1185 10.7955 13.3295C11.0065 13.5405 11.125 13.8266 11.125 14.125Z"
      fill="#ACACAC"
    />
  </Icon>
);

export const WarningOutlineIcon = (props: IconProps) => (
  <Icon {...props} width="22" height="20" viewBox="0 0 22 20" fill="none">
    <path
      d="M21.2 16.1335L13.0016 1.89569C12.7967 1.54687 12.5042 1.25764 12.1532 1.05668C11.8021 0.85572 11.4046 0.75 11 0.75C10.5955 0.75 10.198 0.85572 9.8469 1.05668C9.49581 1.25764 9.20334 1.54687 8.99847 1.89569L0.800029 16.1335C0.602907 16.4709 0.499023 16.8546 0.499023 17.2454C0.499023 17.6361 0.602907 18.0199 0.800029 18.3572C1.00228 18.7082 1.29425 18.999 1.64599 19.1998C1.99773 19.4006 2.39658 19.5043 2.80159 19.5001H19.1985C19.6032 19.5039 20.0016 19.4001 20.353 19.1993C20.7044 18.9985 20.9961 18.7079 21.1982 18.3572C21.3956 18.02 21.4998 17.6364 21.5001 17.2456C21.5004 16.8549 21.3969 16.4711 21.2 16.1335ZM19.8997 17.6063C19.8282 17.7282 19.7256 17.8289 19.6024 17.8981C19.4792 17.9673 19.3398 18.0025 19.1985 18.0001H2.80159C2.66029 18.0025 2.52088 17.9673 2.39765 17.8981C2.27442 17.8289 2.17181 17.7282 2.10034 17.6063C2.0356 17.4967 2.00145 17.3717 2.00145 17.2444C2.00145 17.1171 2.0356 16.9922 2.10034 16.8826L10.2988 2.64475C10.3717 2.52341 10.4748 2.42301 10.598 2.3533C10.7212 2.2836 10.8603 2.24696 11.0019 2.24696C11.1435 2.24696 11.2826 2.2836 11.4058 2.3533C11.529 2.42301 11.6321 2.52341 11.705 2.64475L19.9035 16.8826C19.9676 16.9925 20.0011 17.1176 20.0005 17.2449C19.9998 17.3722 19.965 17.497 19.8997 17.6063ZM10.25 12.0001V8.25006C10.25 8.05115 10.329 7.86038 10.4697 7.71973C10.6104 7.57908 10.8011 7.50006 11 7.50006C11.1989 7.50006 11.3897 7.57908 11.5304 7.71973C11.671 7.86038 11.75 8.05115 11.75 8.25006V12.0001C11.75 12.199 11.671 12.3897 11.5304 12.5304C11.3897 12.671 11.1989 12.7501 11 12.7501C10.8011 12.7501 10.6104 12.671 10.4697 12.5304C10.329 12.3897 10.25 12.199 10.25 12.0001ZM12.125 15.3751C12.125 15.5976 12.059 15.8151 11.9354 16.0001C11.8118 16.1851 11.6361 16.3293 11.4305 16.4144C11.225 16.4996 10.9988 16.5219 10.7806 16.4784C10.5623 16.435 10.3619 16.3279 10.2045 16.1706C10.0472 16.0132 9.94005 15.8128 9.89665 15.5945C9.85324 15.3763 9.87552 15.1501 9.96066 14.9445C10.0458 14.739 10.19 14.5633 10.375 14.4397C10.56 14.316 10.7775 14.2501 11 14.2501C11.2984 14.2501 11.5845 14.3686 11.7955 14.5796C12.0065 14.7905 12.125 15.0767 12.125 15.3751Z"
      fill="#DB3C23"
    />
  </Icon>
);

export const UpdateIcon = (props: IconProps) => (
  <Icon
    {...props}
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 1.99993V4.99993C13 5.13253 12.9473 5.25971 12.8536 5.35348C12.7598 5.44725 12.6326 5.49993 12.5 5.49993H9.50003C9.36742 5.49993 9.24024 5.44725 9.14647 5.35348C9.0527 5.25971 9.00003 5.13253 9.00003 4.99993C9.00003 4.86732 9.0527 4.74014 9.14647 4.64637C9.24024 4.5526 9.36742 4.49993 9.50003 4.49993H11.2125L9.55065 2.97743L9.53503 2.96243C8.84007 2.26773 7.95582 1.79321 6.99275 1.59814C6.02967 1.40307 5.03047 1.4961 4.11996 1.86561C3.20945 2.23512 2.428 2.86473 1.87324 3.67578C1.31847 4.48683 1.01499 5.44336 1.00069 6.42589C0.986395 7.40842 1.26192 8.37338 1.79286 9.20022C2.32379 10.0271 3.08659 10.6791 3.98597 11.075C4.88534 11.4708 5.88142 11.5929 6.84976 11.4259C7.8181 11.259 8.71578 10.8104 9.43065 10.1362C9.52704 10.045 9.6557 9.99586 9.78832 9.99955C9.92095 10.0032 10.0467 10.0595 10.1378 10.1559C10.229 10.2523 10.2782 10.3809 10.2745 10.5135C10.2708 10.6462 10.2145 10.7719 10.1182 10.863C9.00657 11.9173 7.532 12.5034 6.00003 12.4999H5.91753C4.93486 12.4865 3.97055 12.2318 3.10934 11.7584C2.24813 11.285 1.51639 10.6073 0.978437 9.78484C0.440484 8.96239 0.112788 8.0204 0.0241505 7.04165C-0.0644873 6.0629 0.0886469 5.07736 0.470094 4.17165C0.85154 3.26594 1.44962 2.46779 2.21177 1.84736C2.97392 1.22693 3.8768 0.803199 4.84106 0.613422C5.80532 0.423645 6.80143 0.473629 7.74185 0.75898C8.68226 1.04433 9.53819 1.55631 10.2344 2.24993L12 3.86243V1.99993C12 1.86732 12.0527 1.74014 12.1465 1.64637C12.2402 1.5526 12.3674 1.49993 12.5 1.49993C12.6326 1.49993 12.7598 1.5526 12.8536 1.64637C12.9473 1.74014 13 1.86732 13 1.99993Z"
      fill="#646464"
    />
  </Icon>
);

export const SlenderChevronRightIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 4.5L13.25 10.75L7 17"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export const CycleIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 16 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.67435 14.6723C1.33824 14.0917 1.08615 13.4959 0.918099 12.8848C0.750043 12.2737 0.666016 11.6473 0.666016 11.0056C0.666016 8.95841 1.37643 7.21674 2.79727 5.78063C4.2181 4.34452 5.95213 3.62646 7.99935 3.62646H8.15977L6.6931 2.1598L7.97643 0.876465L11.6431 4.54313L7.97643 8.2098L6.6931 6.92646L8.15977 5.4598H7.99935C6.47157 5.4598 5.17296 5.99834 4.10352 7.07542C3.03407 8.15251 2.49935 9.46257 2.49935 11.0056C2.49935 11.4029 2.54518 11.7924 2.63685 12.1744C2.72852 12.5563 2.86602 12.9306 3.04935 13.2973L1.67435 14.6723ZM8.02227 21.0431L4.3556 17.3765L8.02227 13.7098L9.3056 14.9931L7.83893 16.4598H7.99935C9.52713 16.4598 10.8257 15.9213 11.8952 14.8442C12.9646 13.7671 13.4994 12.457 13.4994 10.914C13.4994 10.5167 13.4535 10.1272 13.3619 9.74521C13.2702 9.36327 13.1327 8.98896 12.9494 8.6223L14.3244 7.2473C14.6605 7.82785 14.9125 8.42369 15.0806 9.0348C15.2487 9.64591 15.3327 10.2723 15.3327 10.914C15.3327 12.9612 14.6223 14.7029 13.2014 16.139C11.7806 17.5751 10.0466 18.2931 7.99935 18.2931H7.83893L9.3056 19.7598L8.02227 21.0431Z"
      fill="currentColor"
    />
  </Icon>
);

export const HistoryIcon = (props: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 17.21C7.85417 17.21 6.7809 16.9923 5.78021 16.5568C4.77951 16.1214 3.90868 15.5332 3.16771 14.7923C2.42674 14.0513 1.83854 13.1804 1.40312 12.1798C0.967708 11.1791 0.75 10.1058 0.75 8.95996C0.75 7.81413 0.967708 6.74086 1.40312 5.74017C1.83854 4.73947 2.42674 3.86864 3.16771 3.12767C3.90868 2.3867 4.77951 1.7985 5.78021 1.36309C6.7809 0.927669 7.85417 0.709961 9 0.709961C10.2528 0.709961 11.4406 0.977322 12.5635 1.51204C13.6865 2.04677 14.6375 2.80302 15.4167 3.78079V1.62663H17.25V7.12663H11.75V5.29329H14.2708C13.6444 4.43774 12.8729 3.76552 11.9563 3.27663C11.0396 2.78774 10.0542 2.54329 9 2.54329C7.2125 2.54329 5.69618 3.16586 4.45104 4.411C3.2059 5.65614 2.58333 7.17246 2.58333 8.95996C2.58333 10.7475 3.2059 12.2638 4.45104 13.5089C5.69618 14.7541 7.2125 15.3766 9 15.3766C10.6042 15.3766 12.0059 14.8572 13.2052 13.8183C14.4045 12.7794 15.1111 11.4655 15.325 9.87663H17.2042C16.975 11.9697 16.0774 13.7152 14.5115 15.1131C12.9455 16.511 11.1083 17.21 9 17.21ZM11.5667 12.81L8.08333 9.32663V4.37663H9.91667V8.59329L12.85 11.5266L11.5667 12.81Z"
      fill="currentColor"
    />
  </Icon>
);
